"use client"
import { useState, type JSX } from "react"
import { pingText, type LocaleStatusRow } from "@/lib/review/overview"

const tierBreakdown = (row: LocaleStatusRow) =>
  row.tiers.map((t) => `${t.tier} ${t.count}`).join(" · ")

function Row({
  row,
  reviewLink,
}: {
  row: LocaleStatusRow
  reviewLink: string
}): JSX.Element {
  const [copied, setCopied] = useState(false)
  async function copy() {
    await navigator.clipboard.writeText(pingText(row, reviewLink))
    setCopied(true)
    setTimeout(() => setCopied(false), 1600)
  }
  const signedOff = row.count === 0
  return (
    <li
      className="ahead-review-board-row"
      data-state={
        signedOff ? "done" : row.unassigned ? "unassigned" : "pending"
      }
    >
      <span className="ahead-review-board-locale">{row.locale}</span>
      {signedOff ? (
        <span className="ahead-review-board-status">
          ✅ signed off{row.inViewerScope ? " (you)" : ""}
        </span>
      ) : (
        <>
          <span className="ahead-review-board-status">
            {row.unassigned ? "⚠ " : "⏳ "}
            {row.count} left
            {row.tiers.length > 1 ? (
              <span className="ahead-review-board-tiers">
                {" "}
                · {tierBreakdown(row)}
              </span>
            ) : null}
            {row.inViewerScope ? " (you)" : ""}
          </span>
          {row.unassigned ? (
            <span className="ahead-review-board-help">
              nobody assigned — ask an admin to add a reviewer
            </span>
          ) : (
            <span className="ahead-review-board-help">
              → {row.reviewers.join(", ")}
              {!row.inViewerScope ? (
                <button
                  type="button"
                  className="ahead-review-board-ping"
                  aria-label={`Copy ping for ${row.locale}`}
                  aria-live="polite"
                  onClick={copy}
                >
                  {copied ? "✓ copied" : "copy ping"}
                </button>
              ) : null}
            </span>
          )}
        </>
      )}
    </li>
  )
}

/** Per-locale PR sign-off board. Presentational — caller supplies the rows + link. */
export function PrStatusBoard({
  rows,
  reviewLink,
}: {
  rows: LocaleStatusRow[]
  reviewLink: string
}): JSX.Element {
  return (
    <ul className="ahead-review-board">
      {rows.map((row) => (
        <Row key={row.locale} row={row} reviewLink={reviewLink} />
      ))}
    </ul>
  )
}
